<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('homepage.monitor')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>

            <section class="section py-3">
                <div class="container">
                    <el-row :gutter="15">
                        <el-col :sm="24" :md="12" :lg="8">
                            <div class="card card-lift shadow border-0 card-murojaat_diag  mb-3 mb-lg-3">
                                <div class="card-murojaat_border">
                                    <img class="murojaat_img" src="img/icons/murojaat/contract.svg">
                                    <h2 class="murojaat_h2">250</h2>
                                    <h5 class="murojaat_title">{{$t('homepage.bosh_murojaat')}}</h5>
                                    <span class="murojaat_status"><i class="el-icon-date"></i> Июнь 2020</span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="8">
                            <div class="card card-lift shadow border-0 card-murojaat_diag  mb-3 mb-lg-3">
                                <div class="card-murojaat_border">
                                    <img class="murojaat_img" src="img/icons/murojaat/archive.svg">
                                    <h2 class="murojaat_h2">200</h2>
                                    <h5 class="murojaat_title">{{$t('homepage.bosh_murojaat1')}}</h5>
                                    <span class="murojaat_status"><i class="el-icon-date"></i> Июнь 2020</span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :sm="24" :md="12" :lg="8">
                            <div class="card card-lift shadow border-0 card-murojaat_diag  mb-3 mb-lg-3">
                                <div class="card-murojaat_border">
                                    <img class="murojaat_img" src="img/icons/murojaat/user-data.svg">
                                    <h2 class="murojaat_h2">50</h2>
                                    <h5 class="murojaat_title">{{$t('homepage.bosh_murojaat2')}}</h5>
                                    <span class="murojaat_status"><i class="el-icon-date"></i> Июнь 2020</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped>
    /deep/ .px-4 {
        min-height: 356px;
    }

    /deep/ .profile-page .card-profile {
        margin-top: 70px;
    }
</style>
